import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Fuel, LayoutDashboard, Users, LogOut } from 'lucide-react';
import { ChangePasswordDialog } from '@/components/ChangePassword';
import { ThemeToggle } from '@/components/ThemeToggle';

const items = [
  { to: '/pump', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/pump/crm', icon: Users, label: 'Party CRM' },
];

export const PumpLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 bg-primary text-primary-foreground">
        <div className="mx-auto max-w-7xl px-4 h-14 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 font-semibold"><Fuel className="h-5 w-5" />Petrol Pump · Daily Sales</div>
          <nav className="flex items-center gap-1">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} data-testid={`pump-nav-${it.label.toLowerCase().replace(/ /g, '-')}`}
                className={({ isActive }) => `px-3 py-1.5 rounded-md text-sm font-medium flex items-center gap-1.5 transition-colors ${isActive ? 'bg-white/15' : 'text-white/75 hover:text-white hover:bg-white/10'}`}>
                <it.icon className="h-4 w-4" />{it.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <span className="text-xs text-white/70 hidden sm:block">{user?.name}</span>
            <ThemeToggle className="text-white hover:bg-white/10 h-8 w-8" />
            <ChangePasswordDialog triggerClassName="text-white hover:bg-white/10 h-8 w-8" />
            <Button size="sm" variant="ghost" className="text-white hover:bg-white/10" onClick={async () => { await logout(); nav('/signin'); }} data-testid="pump-logout-button"><LogOut className="h-4 w-4" /></Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-5">{children}</main>
    </div>
  );
};
